import type * as Types from '../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchCoordinateListTileQueryVariables = Types.Exact<{
  coordinateListIds: Types.InputMaybe<Array<Types.Scalars['Long']['input']> | Types.Scalars['Long']['input']>;
}>;


export type FetchCoordinateListTileQuery = { coordinateLists: Array<{ id: number, name: string | null, description: string | null, modified: string, created: string, hidden: boolean, deleted: boolean | null, creator: { display: string | null } | null, project: { id: number, name: string, color: string | null } | null, organism: { id: number } | null }> };

export type GetTableValueParamForViewIdQueryVariables = Types.Exact<{
  viewId: Types.Scalars['Long']['input'];
}>;


export type GetTableValueParamForViewIdQuery = { workflow: { getTableValueParamForViewId: { entityId: number | null, value: { state: { tableView: { selectedIds: Array<number | null> | null, tableQuerySpec: { id: number | null, idType: string | null, queryType: string | null, rowFilter: string | null, restrictions: { refGenomeId: number | null, variantGenomeIds: Array<number | null> | null, region: { contigId: number, range: { start: number, stop: number } | null } | null } | null } | null } | null } | null } | null } } };

export type GetRefGenomeIdsFromGroupQueryVariables = Types.Exact<{
  groupId: Types.Scalars['Long']['input'];
}>;


export type GetRefGenomeIdsFromGroupQuery = { group: { analysisGroup: { refGenomes: Array<{ id: number } | null> | null } | null } | null };

export type GetOrganismsQueryVariables = Types.Exact<{
  orgIds: Array<Types.Scalars['Long']['input']> | Types.Scalars['Long']['input'];
}>;


export type GetOrganismsQuery = { organisms: Array<{ name: string | null, id: number, hidden: boolean, isVirtual: boolean }> };

export type GetOrganismVariantAnalysisQueryVariables = Types.Exact<{
  orgId: Types.Scalars['Long']['input'];
}>;


export type GetOrganismVariantAnalysisQuery = { organism: { name: string | null, id: number, hidden: boolean, variantAnalysisGroups: Array<{ id: number | null } | null> | null } };

export type SaveTableViewMutationVariables = Types.Exact<{
  viewInput: Types.InputWorkflowViewParamInput;
}>;


export type SaveTableViewMutation = { workflow: { saveTableParamViewInput: { name: string | null, value: { id: number } | null } } };


export const FetchCoordinateListTileDocument = gql`
    query fetchCoordinateListTile($coordinateListIds: [Long!]) {
  coordinateLists(coordinateListIds: $coordinateListIds) {
    id
    name
    description
    modified
    created
    creator {
      display
    }
    project {
      id
      name
      color
    }
    organism {
      id
    }
    hidden
    deleted
  }
}
    `;

/**
 * __useFetchCoordinateListTileQuery__
 *
 * To run a query within a React component, call `useFetchCoordinateListTileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCoordinateListTileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCoordinateListTileQuery({
 *   variables: {
 *      coordinateListIds: // value for 'coordinateListIds'
 *   },
 * });
 */
export function useFetchCoordinateListTileQuery(baseOptions?: Apollo.QueryHookOptions<FetchCoordinateListTileQuery, FetchCoordinateListTileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCoordinateListTileQuery, FetchCoordinateListTileQueryVariables>(FetchCoordinateListTileDocument, options);
      }
export function useFetchCoordinateListTileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCoordinateListTileQuery, FetchCoordinateListTileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCoordinateListTileQuery, FetchCoordinateListTileQueryVariables>(FetchCoordinateListTileDocument, options);
        }
export function useFetchCoordinateListTileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCoordinateListTileQuery, FetchCoordinateListTileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCoordinateListTileQuery, FetchCoordinateListTileQueryVariables>(FetchCoordinateListTileDocument, options);
        }
export type FetchCoordinateListTileQueryHookResult = ReturnType<typeof useFetchCoordinateListTileQuery>;
export type FetchCoordinateListTileLazyQueryHookResult = ReturnType<typeof useFetchCoordinateListTileLazyQuery>;
export type FetchCoordinateListTileSuspenseQueryHookResult = ReturnType<typeof useFetchCoordinateListTileSuspenseQuery>;
export type FetchCoordinateListTileQueryResult = Apollo.QueryResult<FetchCoordinateListTileQuery, FetchCoordinateListTileQueryVariables>;
export const GetTableValueParamForViewIdDocument = gql`
    query getTableValueParamForViewId($viewId: Long!) {
  workflow {
    getTableValueParamForViewId(viewId: $viewId) {
      entityId
      value {
        state {
          tableView {
            selectedIds
            tableQuerySpec {
              id
              idType
              queryType
              restrictions {
                refGenomeId
                variantGenomeIds
                region {
                  contigId
                  range {
                    start
                    stop
                  }
                }
              }
              rowFilter
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTableValueParamForViewIdQuery__
 *
 * To run a query within a React component, call `useGetTableValueParamForViewIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableValueParamForViewIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableValueParamForViewIdQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useGetTableValueParamForViewIdQuery(baseOptions: Apollo.QueryHookOptions<GetTableValueParamForViewIdQuery, GetTableValueParamForViewIdQueryVariables> & ({ variables: GetTableValueParamForViewIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTableValueParamForViewIdQuery, GetTableValueParamForViewIdQueryVariables>(GetTableValueParamForViewIdDocument, options);
      }
export function useGetTableValueParamForViewIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTableValueParamForViewIdQuery, GetTableValueParamForViewIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTableValueParamForViewIdQuery, GetTableValueParamForViewIdQueryVariables>(GetTableValueParamForViewIdDocument, options);
        }
export function useGetTableValueParamForViewIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTableValueParamForViewIdQuery, GetTableValueParamForViewIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTableValueParamForViewIdQuery, GetTableValueParamForViewIdQueryVariables>(GetTableValueParamForViewIdDocument, options);
        }
export type GetTableValueParamForViewIdQueryHookResult = ReturnType<typeof useGetTableValueParamForViewIdQuery>;
export type GetTableValueParamForViewIdLazyQueryHookResult = ReturnType<typeof useGetTableValueParamForViewIdLazyQuery>;
export type GetTableValueParamForViewIdSuspenseQueryHookResult = ReturnType<typeof useGetTableValueParamForViewIdSuspenseQuery>;
export type GetTableValueParamForViewIdQueryResult = Apollo.QueryResult<GetTableValueParamForViewIdQuery, GetTableValueParamForViewIdQueryVariables>;
export const GetRefGenomeIdsFromGroupDocument = gql`
    query getRefGenomeIdsFromGroup($groupId: Long!) {
  group(groupId: $groupId) {
    analysisGroup {
      refGenomes {
        id
      }
    }
  }
}
    `;

/**
 * __useGetRefGenomeIdsFromGroupQuery__
 *
 * To run a query within a React component, call `useGetRefGenomeIdsFromGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRefGenomeIdsFromGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRefGenomeIdsFromGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetRefGenomeIdsFromGroupQuery(baseOptions: Apollo.QueryHookOptions<GetRefGenomeIdsFromGroupQuery, GetRefGenomeIdsFromGroupQueryVariables> & ({ variables: GetRefGenomeIdsFromGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRefGenomeIdsFromGroupQuery, GetRefGenomeIdsFromGroupQueryVariables>(GetRefGenomeIdsFromGroupDocument, options);
      }
export function useGetRefGenomeIdsFromGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRefGenomeIdsFromGroupQuery, GetRefGenomeIdsFromGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRefGenomeIdsFromGroupQuery, GetRefGenomeIdsFromGroupQueryVariables>(GetRefGenomeIdsFromGroupDocument, options);
        }
export function useGetRefGenomeIdsFromGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRefGenomeIdsFromGroupQuery, GetRefGenomeIdsFromGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRefGenomeIdsFromGroupQuery, GetRefGenomeIdsFromGroupQueryVariables>(GetRefGenomeIdsFromGroupDocument, options);
        }
export type GetRefGenomeIdsFromGroupQueryHookResult = ReturnType<typeof useGetRefGenomeIdsFromGroupQuery>;
export type GetRefGenomeIdsFromGroupLazyQueryHookResult = ReturnType<typeof useGetRefGenomeIdsFromGroupLazyQuery>;
export type GetRefGenomeIdsFromGroupSuspenseQueryHookResult = ReturnType<typeof useGetRefGenomeIdsFromGroupSuspenseQuery>;
export type GetRefGenomeIdsFromGroupQueryResult = Apollo.QueryResult<GetRefGenomeIdsFromGroupQuery, GetRefGenomeIdsFromGroupQueryVariables>;
export const GetOrganismsDocument = gql`
    query getOrganisms($orgIds: [Long!]!) {
  organisms(organismIds: $orgIds) {
    name
    id
    hidden
    isVirtual
  }
}
    `;

/**
 * __useGetOrganismsQuery__
 *
 * To run a query within a React component, call `useGetOrganismsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganismsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganismsQuery({
 *   variables: {
 *      orgIds: // value for 'orgIds'
 *   },
 * });
 */
export function useGetOrganismsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganismsQuery, GetOrganismsQueryVariables> & ({ variables: GetOrganismsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganismsQuery, GetOrganismsQueryVariables>(GetOrganismsDocument, options);
      }
export function useGetOrganismsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganismsQuery, GetOrganismsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganismsQuery, GetOrganismsQueryVariables>(GetOrganismsDocument, options);
        }
export function useGetOrganismsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganismsQuery, GetOrganismsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganismsQuery, GetOrganismsQueryVariables>(GetOrganismsDocument, options);
        }
export type GetOrganismsQueryHookResult = ReturnType<typeof useGetOrganismsQuery>;
export type GetOrganismsLazyQueryHookResult = ReturnType<typeof useGetOrganismsLazyQuery>;
export type GetOrganismsSuspenseQueryHookResult = ReturnType<typeof useGetOrganismsSuspenseQuery>;
export type GetOrganismsQueryResult = Apollo.QueryResult<GetOrganismsQuery, GetOrganismsQueryVariables>;
export const GetOrganismVariantAnalysisDocument = gql`
    query getOrganismVariantAnalysis($orgId: Long!) {
  organism(organismId: $orgId) {
    name
    id
    hidden
    variantAnalysisGroups {
      id
    }
  }
}
    `;

/**
 * __useGetOrganismVariantAnalysisQuery__
 *
 * To run a query within a React component, call `useGetOrganismVariantAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganismVariantAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganismVariantAnalysisQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrganismVariantAnalysisQuery(baseOptions: Apollo.QueryHookOptions<GetOrganismVariantAnalysisQuery, GetOrganismVariantAnalysisQueryVariables> & ({ variables: GetOrganismVariantAnalysisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganismVariantAnalysisQuery, GetOrganismVariantAnalysisQueryVariables>(GetOrganismVariantAnalysisDocument, options);
      }
export function useGetOrganismVariantAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganismVariantAnalysisQuery, GetOrganismVariantAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganismVariantAnalysisQuery, GetOrganismVariantAnalysisQueryVariables>(GetOrganismVariantAnalysisDocument, options);
        }
export function useGetOrganismVariantAnalysisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganismVariantAnalysisQuery, GetOrganismVariantAnalysisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganismVariantAnalysisQuery, GetOrganismVariantAnalysisQueryVariables>(GetOrganismVariantAnalysisDocument, options);
        }
export type GetOrganismVariantAnalysisQueryHookResult = ReturnType<typeof useGetOrganismVariantAnalysisQuery>;
export type GetOrganismVariantAnalysisLazyQueryHookResult = ReturnType<typeof useGetOrganismVariantAnalysisLazyQuery>;
export type GetOrganismVariantAnalysisSuspenseQueryHookResult = ReturnType<typeof useGetOrganismVariantAnalysisSuspenseQuery>;
export type GetOrganismVariantAnalysisQueryResult = Apollo.QueryResult<GetOrganismVariantAnalysisQuery, GetOrganismVariantAnalysisQueryVariables>;
export const SaveTableViewDocument = gql`
    mutation saveTableView($viewInput: InputWorkflowViewParamInput!) {
  workflow {
    saveTableParamViewInput(viewInput: $viewInput) {
      name
      value {
        id
      }
    }
  }
}
    `;
export type SaveTableViewMutationFn = Apollo.MutationFunction<SaveTableViewMutation, SaveTableViewMutationVariables>;

/**
 * __useSaveTableViewMutation__
 *
 * To run a mutation, you first call `useSaveTableViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTableViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTableViewMutation, { data, loading, error }] = useSaveTableViewMutation({
 *   variables: {
 *      viewInput: // value for 'viewInput'
 *   },
 * });
 */
export function useSaveTableViewMutation(baseOptions?: Apollo.MutationHookOptions<SaveTableViewMutation, SaveTableViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTableViewMutation, SaveTableViewMutationVariables>(SaveTableViewDocument, options);
      }
export type SaveTableViewMutationHookResult = ReturnType<typeof useSaveTableViewMutation>;
export type SaveTableViewMutationResult = Apollo.MutationResult<SaveTableViewMutation>;
export type SaveTableViewMutationOptions = Apollo.BaseMutationOptions<SaveTableViewMutation, SaveTableViewMutationVariables>;